import { render, staticRenderFns } from "./floating_active_call.vue?vue&type=template&id=c3cd69ce&scoped=true&"
import script from "./floating_active_call.vue?vue&type=script&lang=js&"
export * from "./floating_active_call.vue?vue&type=script&lang=js&"
import style0 from "./floating_active_call.vue?vue&type=style&index=0&id=c3cd69ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3cd69ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VSheet,VTooltip})
